import { render, staticRenderFns } from "./IconInformation.vue?vue&type=template&id=383ecb8c&scoped=true&"
import script from "./IconInformation.vue?vue&type=script&lang=js&"
export * from "./IconInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383ecb8c",
  null
  
)

export default component.exports